module.exports = __webpack_public_path__ + "img/bianzu13.76821a3d.png";